import type { ButtonHTMLAttributes,FC } from 'react'

import classNames from '../../utils/classNames'

const ConfirmButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  className,
  ...props
}) => {
  return (
    <button
      {...props}
      className={classNames(
        'flex items-center justify-center w-full h-[45px] lg:h-[50px] text-sm lg:text-base text-white font-Syncopate-Bold uppercase rounded-[5px]',
        'lg:py-[9px] opacity-1 bg-highlight [&.secondary]:bg-[#65676a] disabled:bg-[#65676a] disabled:text-[#d9d9d9] transition-all duration-200 ease-in-out',
        className,
      )}>
      {props.children}
    </button>
  )
}

export default ConfirmButton
